<template>
  <v-app dark>
    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>Guilds and Gauges</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        v-if="this.$store.state.started"
        @click="toggleStarted()"
        :color="'#DCA145'"
      >Select Players</v-btn>
      <v-btn
        v-if="this.$store.state.started"
        @click="toggleDrawer()"
        :color="'#a44a6d'"
      >Guild Status</v-btn>
    </v-toolbar>
    <v-content class="bg">
      <v-navigation-drawer
        v-model="drawer"
        absolute
        temporary
        width="800"
        :style="{ position: drawer ? 'fixed' : ''}"
        :floating="true"
        :clipped="true"
        class="bg"
      >
        <guild-status/>
      </v-navigation-drawer>
      <player-selection/>
      <guild-card
        v-for="player in this.$store.getters.selectedPlayers"
        :key="player.id"
        :player="player"
      />
    </v-content>
  </v-app>
</template>

<script>
import GuildCard from "./components/GuildCard";
import PlayerSelection from "./components/PlayerSelection";
import GuildStatus from "./components/GuildStatus";

export default {
  name: "App",
  components: {
    GuildCard,
    PlayerSelection,
    GuildStatus
  },
  data() {
    return {
      drawer: null
    };
  },
  methods: {
    toggleStarted() {
      this.$store.dispatch("toggleStarted");
    },
    toggleDrawer() {
      this.drawer = !this.drawer;
    }
  }
};
</script>
<style>
.bg {
  background-image: linear-gradient(
    to right bottom,
    #9e4a6e,
    #b95667,
    #cc685c,
    #d87e52,
    #da984a
  );
}
body {
   -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
}
</style>
